[
  {
    "id": "07",
    "slug": "senda",
    "title": "Senda",
    "claim": "Humanizing digital payments for seniors.",
    "summary": "Senda is a digital payment solution designed for people over 70 who need to make online transactions securely and easily. It allows users to pay without exposing their main bank account or relying on complex apps, promoting independence and reducing digital exclusion.", 
    "tags": ["UX", "UI", "Visual Identity"],
    "year": "2026",
    "hero": "/media/senda/senda-01-hero.jpg", 
    "thumbnail": "/media/senda/senda-01-hero.jpg", 
    "featured": true,
    "type": "case study",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["UX Research", "Product Design"],
    "tools": ["FigJam", "Figma", "Maze"],
    "team": ["Laura Caballero García", "Elena Ivars Martínez", "Andrea Navarro Silla", "Elena Ramadán Mata"],
    "client": "University project"
  },
  {
    "id": "09",
    "slug": "bloq",
    "title": "Bloq",
    "claim":"Reimagining home audio as a tool for connection.",
    "summary": "Exploración de patrones de diseño de interfaz que reducen el consumo energético sin comprometer la experiencia de uso.",
    "tags": ["Strategy","Branding", "UI"],
    "year": "2026",
    "hero": "/media/bloq/bloq-00-thumbnail.webp",
    "thumbnail": "/media/bloq/bloq-00-thumbnail.webp", 
    "featured": true,
    "type": "case study",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Figma", "Krea"],
    "team": ["Laura Caballero García", "Luca Giordano", "Andrea Navarro Silla", "Nicolás Rodríguez Ramos", "Isla Pearce Cano"],
    "client": "University project"
  },
  {
    "id": "08",
    "slug": "hallo",
    "title": "Hallo",
    "summary": "Simplifying energy management for young households.",
    "tags": ["UI"],
    "year": "2026",
    "thumbnail": "/media/senda/senda-01-hero.jpg", 
    "featured": false,
    "type": "case study",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Figma", "Krea"],
    "team": ["Laura Caballero García", "Luca Giordano", "Andrea Navarro Silla", "Nicolás Rodríguez Ramos", "Isla Pearce Cano"],
    "client": "University project"
  },
  {
    "id": "06",
    "slug": "parc-central",
    "title": "Parc Central",
    "claim": "Visual Identity for Valencias’s urban green space.",
    "summary": "Valencia’s Parc Central is a vibrant and inclusive urban green space where nature, culture, and sport coexist. Its visual identity uses the exquisite corpse technique, merging independent elements into a dynamic system that reflects the park’s diverse activities and interactions.",
    "tags": ["Visual Identity"],
    "year": "2025",
    "hero": "/media/parc-central/parc-central-01-hero.webp", 
    "thumbnail": "/media/parc-central/parc-central-00-thumbnail.webp", 
    "featured": true,
    "type": "work",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Adobe Suite", "Figma"],
    "team": ["Laura Caballero García", "Mariana Birdici","Andrea Donderis Delcamp", "Carola Hinojosa Torres","Beatriz Ortiz Monet", "Laura Palau"],
    "client": "University project"
  }, 
  {
    "id": "05",
    "slug": "editorial-la-dispersa",
    "title": "Editorial La Dispersa",
    "claim": "A toast to the first words of love.",
    "summary": "Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.",
    "tags": ["Art direction"],
    "year": "2024",
    "hero": "/media/xana/xana-01-hero.webp", 
    "thumbnail": "/media/xana/xana-00-thumbnail.webp", 
    "featured": false,
    "type": "work",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Adobe Suite"],
    "team": ["Laura Caballero García", "Andrea Donderis Delcamp"],
    "client": "University project"
  }, 
  {
    "id": "04",
    "slug": "xana",
    "title": "Xana",
    "claim": "A toast to the first words of love.",
    "summary": "Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.",
    "tags": ["Art direction"],
    "year": "2024",
    "hero": "/media/xana/xana-01-hero.webp", 
    "thumbnail": "/media/xana/xana-00-thumbnail.webp", 
    "featured": false,
    "type": "work",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Adobe Suite"],
    "team": ["Laura Caballero García", "Andrea Donderis Delcamp"],
    "client": "University project"
  }, 
  {
    "id": "03",
    "slug": "fuv",
    "title": "FUV",
    "claim": "A toast to the first words of love.",
    "summary": "Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.",
    "tags": ["Art direction"],
    "year": "2024",
    "hero": "/media/xana/xana-01-hero.webp", 
    "thumbnail": "/media/xana/xana-00-thumbnail.webp", 
    "featured": false,
    "type": "work",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Adobe Suite"],
    "team": ["Laura Caballero García", "Andrea Donderis Delcamp"],
    "client": "University project"
  }, 
  {
    "id": "02",
    "slug": "attic",
    "title": "Attic",
    "claim": "A toast to the first words of love.",
    "summary": "Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.",
    "tags": ["Art direction"],
    "year": "2024",
    "hero": "/media/xana/xana-01-hero.webp", 
    "thumbnail": "/media/xana/xana-00-thumbnail.webp", 
    "featured": false,
    "type": "work",
    "timeline": "Sep 2024 – Jan 2025",
    "roles": ["", ""],
    "tools": ["Adobe Suite"],
    "team": ["Laura Caballero García", "Andrea Donderis Delcamp"],
    "client": "University project"
  }, 
  {
    "id": "01",
    "slug": "blink",
    "title": "Blink",
    "claim": "A motion festival shaped by the movement of the street.",
    "summary": "Blink is a motion design festival inspired by the restless energy of urban life and the speed at which the world unfolds in the blink of an eye. Through overlapping elements, noisy textures, flashes of light and vibrant colours, its visual identity captures the constant movement of the streets across digital and physical touchpoints.", 
    "tags": ["Art direction", "Visual identity", "UI"],
    "year": "2024",
    "hero": "/media/xana/xana-01-hero.webp", 
    "thumbnail": "/media/xana/xana-00-thumbnail.webp", 
    "featured": true,
    "type": "work",
    "timeline": "Dec 2023 – Jan 2024",
    "roles": ["Motion Design", "Web Design"],
    "tools": ["Adobe Suite", "Figma"],
    "team": ["Laura Caballero García", "Andrea Donderis Delcamp", "Elena Barrachina Barrachina"],
    "client": "University project"
  }
]
